import { render } from "./TriggerOrderUpdate.vue?vue&type=template&id=887b04e0&scoped=true"
import script from "./TriggerOrderUpdate.vue?vue&type=script&lang=js"
export * from "./TriggerOrderUpdate.vue?vue&type=script&lang=js"

import "./TriggerOrderUpdate.vue?vue&type=style&index=0&id=887b04e0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-887b04e0"]])

export default __exports__